let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fnoJZ")).then(() => parcelRequire('7He8T'));